(function ($) {
  $.fn.extend({
    Scroll: function (opt, callback) {
      if (!opt) var opt = {};
      var _btnUp = $("#" + opt.up);
      var _btnDown = $("#" + opt.down);

      // var _this = this.eq(_btntabnum).find("ul:first");
      for (var tabnum = 0; tabnum < 4; tabnum++) {

        let timerID;
        let _this = this.eq(tabnum).find("ul:first");
  
        let lineH = _this.find("li:first").height()==undefined?35:_this.find("li:first").height(),
          line = opt.line ? parseInt(opt.line, 10) : parseInt(this.height() / lineH, 10),
          speed = opt.speed ? parseInt(opt.speed, 10) : 500;
          let autolineH = opt.autoline;
          let timer = opt.timer //?parseInt(opt.timer,10):3000; //滚动的时间间隔（毫秒）
        if (line == 0) line = 1;
        let upHeight = 0 - line * lineH;
        let autoupHeight = 0 - autolineH * lineH;
      

        let scrollUp_auto = function () {
          _btnUp.unbind("click", scrollUp); //Shawphy:取消向上按钮的函数绑定
          _this.animate({
            marginTop: autoupHeight
          }, speed, function () {
            for (var i = 1; i <= 1; i++) {
              _this.find("li:first").appendTo(_this);
            }
            _this.css({
              marginTop: 0
            });
            _btnUp.bind("click", scrollUp); //Shawphy:绑定向上按钮的点击事件
          });

        }

        //向上翻页函数
        let scrollUp = function () {
          _btnUp.unbind("click", scrollUp); //Shawphy:取消向上按钮的函数绑定
          _this.animate({
            marginTop: upHeight
          }, speed, function () {
            for (var i = 1; i <= line; i++) {
              _this.find("li:first").appendTo(_this);
            }
            _this.css({
              marginTop: 0
            });
            _btnUp.bind("click", scrollUp); //Shawphy:绑定向上按钮的点击事件
          });

        }
        //向下翻页函数
        let scrollDown = function () {
          _btnDown.unbind("click", scrollDown);
          for (var i = 1; i <= line; i++) {
            _this.find("li:last").show().prependTo(_this);
          }
          _this.css({
            marginTop: upHeight
          });
          _this.animate({
            marginTop: 0
          }, speed, function () {
            _btnDown.bind("click", scrollDown);
          });
        }
        //Shawphy:自动播放
        let autoPlay = function () {
          if (timer) timerID = window.setInterval(scrollUp_auto, timer);
        };
        let autoStop = function () {
          if (timer) window.clearInterval(timerID);
        };
    
        //鼠标事件绑定
        _this.hover(autoStop, autoPlay).mouseout();
        _btnUp.css("cursor", "pointer").click(scrollUp).hover(autoStop, autoPlay); //Shawphy:向上向下鼠标事件绑定
        _btnDown.css("cursor", "pointer").click(scrollDown).hover(autoStop, autoPlay);
      }
    }
  })
})(jQuery);
